import { isFunction } from 'lodash/fp';
import { call, put } from 'redux-saga/effects';
import showFailedRequestError from './showFailedRequestError';

export function* sagaCallWithLifecycle(
  name,
  request,
  options = {},
  sagaOptions = {}
) {
  try {
    yield put({ type: `${name}_started`, ...sagaOptions });
    const result = yield call(request, options);
    yield put({ type: `${name}_succeed`, result, ...sagaOptions });
    return result;
  } catch (error) {
    yield put({ type: `${name}_failed`, error });
    return error;
  } finally {
    yield put({ type: `${name}_finished` });
  }
}

export function* sagaRequest({
  request,
  started,
  succeed,
  failed,
  finished,
  actionProps = {}
}) {
  const { type, url, options } = request;
  try {
    yield put({ ...actionProps, type: `${type}_started` });
    yield isFunction(started) && started();
    const result = yield call(url, options);
    yield put({ ...actionProps, type: `${type}_succeed`, result });
    yield isFunction(succeed) && succeed(result);
    return result;
  } catch (error) {
    yield put({ ...actionProps, type: `${type}_failed`, error });
    yield isFunction(failed) && failed(error);
    return error;
  } finally {
    yield put({ ...actionProps, type: `${type}_finished` });
    yield isFunction(finished) && finished();
  }
}

export function* sagaRoutineRequest(
  routine,
  { request, success, failure, fulfill, successPayload = {} }
) {
  try {
    // Requst
    yield put(routine.request());
    const response = yield request();
    // Success
    yield put(routine.success({ ...successPayload, response }));
    yield isFunction(success) && success(response);
    return response;
  } catch (error) {
    // Error
    yield put(routine.failure(error));
    if (isFunction(failure)) {
      yield failure(error);
    } else {
      showFailedRequestError(error);
    }
    return error;
  } finally {
    // Fulfill
    yield put(routine.fulfill());
    yield isFunction(fulfill) && fulfill();
  }
}
